import React from 'react';
import {useField, useFormikContext} from 'formik';

import {Checkbox as OriginalInput, CheckboxProps} from './checkbox';

export const Checkbox: React.FC<Omit<CheckboxProps, 'onChange' | 'value'> & {
	name: string;
	onCustomChange?: (value: boolean) => void;
}> = props => {
	// @ts-ignore
	const [field, meta] = useField(props);
	const {setFieldValue} = useFormikContext();
	const {onCustomChange, ...fieldProps} = props;
	return (
		<OriginalInput
			{...field}
			{...(fieldProps as any)}
			checked={field.value}
			error={meta.touched && meta.error}
			onChange={value => {
				setFieldValue(field.name as never, value);
				if (onCustomChange) onCustomChange(value);
			}}
		/>
	);
};
